import React, { useEffect, useState } from "react";
import { Col, Row, Table } from "reactstrap";
import useAxios from "../../../Utils/useAxios";
import getPredikatDetail from "../services/getPredikatDetail";
import { SelectionField } from "../../../CommonElements";
import { RekapSubkategoriIndividu } from "../constants/RekapSubkategoriList";
import getSkor from "../utils/rekap/getSkor";
import getSkorRentang from "../utils/rekap/getSkorRentang";

const RekapNilaiIndividu = ({ data, options }) => {
  const axiosInstance = useAxios();
  const [predikatDetail, setPredikatDetail] = useState([]);
  const [uniqueUsers, setUniqueUsers] = useState([]);
  const [recentUnitKerja, setRecentUnitKerja] = useState(27);
  const role = localStorage.getItem("role");
  const unitKerja = localStorage.getItem("unit_kerja");

  useEffect(() => {
    if (data.asesmen.length > 0) {
      // Filter assessments to only include the latest assessment for each user
      const latestAsesmen = data.asesmen.reduce((acc, current) => {
        const existing = acc.find((item) => item.user === current.user);
        if (!existing || existing.id < current.id) {
          return [...acc.filter((item) => item.user !== current.user), current];
        }
        return acc;
      }, []);

      // Fetch details for the latest assessments
      latestAsesmen.forEach((item) => {
        predikatDetails(item.predikats, item.user, item.kebutuhan_pengembangan);
      });
    }
  }, [data.asesmen]);

  useEffect(() => {
    if (data.staf) {
      updateUsers(data.staf);
    }
  }, [recentUnitKerja, data.staf]);

  const predikatDetails = (list, user, kebutuhan_pengembangan) => {
    getPredikatDetail(axiosInstance, list).then((res) => {
      setPredikatDetail((prev) => [
        ...prev,
        {
          user: user,
          data: res.data,
          kebutuhan_pengembangan: kebutuhan_pengembangan,
        },
      ]);
    });
  };

  const updateUsers = (staf) => {
    const users = staf
      .filter((item) => {
        if (role === "Admin") {
          return item.divisi === recentUnitKerja;
        }
        return true;
      })
      .map((item) => item.nama);

    setUniqueUsers([...new Set(users)]);
  };

  const getDataForSubkategori = (subkategoriIndex, user) => {
    const recordUser = predikatDetail.find((userData) =>
      userData.user.includes(user)
    );
    if (!recordUser) {
      return { predikat: "-", skorRentang: "-", koreksi: "-" };
    }
    const record = recordUser.data.find(
      (item) => item?.subkategori == subkategoriIndex + 1
    );
    return record ? record : { predikat: "-", skorRentang: "-", koreksi: "-" };
  };

  const updateUnitKerja = (value) => {
    setRecentUnitKerja(parseInt(value));
  };

  return (
    <div className="App mt-5">
      {role === "Admin" && (
        <Row>
          <Col className={"col-2"}>
            <strong>Unit Kerja</strong>
          </Col>
          <Col>
            <div className="d-flex">
              :{" "}
              <SelectionField
                className={"m-0 py-0 w-50"}
                placeholder={"Pilih Unit Kerja"}
                options={options}
                onChange={(e) => updateUnitKerja(e.target.value)}
              />
            </div>
          </Col>
        </Row>
      )}
      <div style={{ overflowX: "auto", marginTop: "20px" }}>
        <Table bordered>
          <thead>
            <tr>
              <th
                rowSpan="2"
                style={{
                  textAlign: "center",
                  verticalAlign: "middle",
                }}
              >
                Kategori
              </th>
              <th
                rowSpan="2"
                className="px-5"
                style={{
                  textAlign: "center",
                  verticalAlign: "middle",
                }}
              >
                Subkategori
              </th>
              {uniqueUsers.map((user) => (
                <th
                  key={user}
                  colSpan="3"
                  style={{ textAlign: "center", verticalAlign: "middle" }}
                >
                  {user}
                </th>
              ))}
            </tr>
            <tr>
              {uniqueUsers.map((user) => (
                <>
                  <th key={`predikat-${user}`} style={{ textAlign: "center" }}>
                    Skor
                  </th>
                  <th key={`skor-${user}`} style={{ textAlign: "center" }}>
                    Skor (Rentang)
                  </th>
                  <th key={`koreksi-${user}`} style={{ textAlign: "center" }}>
                    Koreksi
                  </th>
                </>
              ))}
            </tr>
          </thead>
          <tbody>
            {RekapSubkategoriIndividu.map((subkategori, index) => (
              <tr key={index}>
                {subkategori.kategori !== "" && (
                  <td
                    style={{
                      textAlign: "center",
                      fontSize: "13px",
                    }}
                    rowSpan={subkategori.rowspan}
                    colSpan={subkategori.colSpan || 1}
                  >
                    {subkategori.kategori}
                  </td>
                )}
                {subkategori.kategori === "Kebutuhan Pengembangan Diri" ? (
                  <>
                    {uniqueUsers.map((user) => {
                      const userKebutuhanPengembangan = predikatDetail.find(
                        (userData) => userData.user.includes(user)
                      )?.kebutuhan_pengembangan;
                      return (
                        <td
                          key={`kebutuhan-pengembangan-${user}`}
                          colSpan="3"
                          style={{ textAlign: "center" }}
                        >
                          {userKebutuhanPengembangan || ""}
                        </td>
                      );
                    })}
                  </>
                ) : (
                  <>
                    <td style={{ fontSize: "13px" }}>
                      {subkategori.subkategori}
                    </td>
                    {uniqueUsers.map((user, idx) => {
                      const { predikat, koreksi } = getDataForSubkategori(
                        index,
                        user
                      );
                      return (
                        <>
                          <td
                            key={`predikat-${index}-${user}`}
                            style={{ textAlign: "center" }}
                          >
                            {getSkor(data.predikat, predikat)}
                          </td>
                          <td
                            key={`skor-${index}-${user}`}
                            style={{ textAlign: "center" }}
                          >
                            {getSkorRentang(data.predikat, predikat)}
                          </td>
                          <td
                            key={`koreksi-${index}-${user}`}
                            style={{ textAlign: "center" }}
                          >
                            {getSkor(data.predikat, koreksi)}
                          </td>
                        </>
                      );
                    })}
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default RekapNilaiIndividu;
